var _circle, _circle2, _circle3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscriptionCircles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 374,
    viewBox: "0 0 260 374",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 87.2292,
    cy: 288.815,
    r: 36.6899,
    transform: "rotate(105 87.2292 288.815)",
    stroke: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 1.89744,
    transform: "matrix(0.258819 -0.965926 -0.965926 -0.258819 75.7579 253.917)",
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 1.89744,
    transform: "matrix(0.258819 -0.965926 -0.965926 -0.258819 123.775 288.785)",
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.0511 130.988C28.9371 202.322 71.2701 275.645 142.604 294.759C213.939 313.873 287.261 271.54 306.375 200.206C325.489 128.871 283.156 55.5486 211.822 36.4346C140.488 17.3207 67.1651 59.6536 48.0511 130.988ZM47.0852 130.729C27.8283 202.597 70.4778 276.468 142.346 295.725C214.213 314.982 288.084 272.332 307.341 200.464C326.598 128.597 283.949 54.7256 212.081 35.4687C140.213 16.2118 66.3421 58.8613 47.0852 130.729Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionCircles);
export default __webpack_public_path__ + "static/media/subscription-circles.2db2386ad4be5cf9f4913e45716391a8.svg";
export { ForwardRef as ReactComponent };